module.exports = __webpack_public_path__ + "static/img/2.02a7ed4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/5/3/zh/2.png
// module id = fk/2
// module chunks = 0